module.exports = __webpack_public_path__ + "static/img/app_banner.7aef938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/app_banner.png
// module id = KDze
// module chunks = 8